export default "__VITE_ASSET__BJY33_hc__"